import * as Yup from 'yup';

export const CompanyInsightSchema = Yup.object().shape({
    name: Yup.string().min(1, 'Company name is required').required('Company name is required'),
    id: Yup.string().min(1, 'Company ID is required').required('Company ID is required'),
});

export type CompanyInsightDataType = Yup.InferType<typeof CompanyInsightSchema>;

type InitialValues = {
    name: string;
    id: string;
};

export const CompanyInsightInitialValues: InitialValues = {
    name: '',
    id: '',
};

export interface CompanyInsightInterface {
    name: string;
    id: string;
}
